module.exports = __webpack_public_path__ + "img/gb100.prt.473c21f7.jpg";